import { TCustomRangeSelectType } from '../components/CustomRangeSelect';
import { TOptionsItem } from '../types';

/**
 * 获取范围选择器的默认值
 * 支持格式：'all'、'数字-数字'（如 '0-50'）、'数字-'（如 '1000-'）
 * @param filterValue 过滤器值
 * @param key 键名
 * @returns 默认值对象
 */
export function getRangeSelectDefaultValue(
  filterValue: any,
  props: TCustomRangeSelectType,
) {
  const { valueKeys: key } = props;
  const value = filterValue?.[key];

  // 如果值为空，返回 'all'
  if (!value) {
    return { [key]: 'all' };
  }

  // 如果是 'all'，直接返回
  if (value === 'all') {
    return { [key]: 'all' };
  }

  // 校验格式：数字-数字 或 数字-
  const rangePattern = /^(\d+)-(\d*)$/;
  const match = value.match(rangePattern);

  if (match) {
    // 格式正确，返回原值
    return { [key]: value };
  }

  // 格式不正确，返回 'all'
  return { [key]: 'all' };
}

/**
 * 将范围选择器的值转换为后端格式
 * @param filterValue 过滤器值
 * @param key 键名
 * @returns 后端格式对象
 */
export function getRangeSelectBackValueFunc(multiplier = 1000) {
  return (filterValue: any, props: TCustomRangeSelectType) => {
    const { valueKeys: key } = props;
    const value = filterValue[key];

    // all 返回空数组
    if (value === 'all') {
      return { [key]: [] };
    }

    // 解析 value 格式，例如 '0-50' 或 '1000-'
    const [startStr, endStr] = value.split('-');
    const start = startStr ? Number(startStr) * multiplier : undefined;
    const end = endStr ? Number(endStr) * multiplier : undefined;

    if (start !== undefined && end !== undefined) {
      return { [key]: [{ start, end }] };
    }

    if (start !== undefined) {
      return { [key]: [{ start }] };
    }

    return { [key]: [] };
  };
}

/**
 * 创建范围选择器的选项
 * 将 '12-15' 格式转换为 '12K-15K' 显示文本
 * @param value 选项值
 * @returns 选项对象
 */
export function createRangeSelectOption(
  value: string,
  unit = 'K',
): TOptionsItem {
  // value 格式为 '12-15'，转换为 '12K-15K' 显示文本
  const [start, end] = value.split('-');
  const displayText = `${start}${unit}-${end}${unit}`;
  return {
    text: displayText,
    textCn: displayText,
    value,
  };
}
